$(() => {

    const banner: HTMLElement = document.getElementById('js-popup-detector');
    if (banner !== null) {
        if (popUpBlockActive()) {
            banner.classList.remove('hidden');
        }
    }
});

function popUpBlockActive() {
    var myPopup = window.open("about:blank", "myWindow","toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=100, height=100");


    if (!myPopup)
        return true;
    else {
        try {
            myPopup.focus();
            myPopup.close();
        }
        catch (e) {
            return true;
        }
    }

    return false;
}
